import React, {createContext, useEffect, useState} from "react";
import './css/App.css';
import './css/modal/Modal.css'

import LoginPage from "./pages/login/LoginPage";
import AdminPage from "./pages/admin/AdminPage";

import proxy from "./utils/Proxy.js"
import UserPage from "./pages/user/UserPage";

export const AdminContext = createContext({});
let App = () => {
    let setScreenSize = () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    window.addEventListener('resize', setScreenSize)
    setScreenSize();

    let [loginLoaded, setLoginLoaded] = useState(false);
    let [isLoggedIn, setIsLoggedIn] = useState(false);
    let [isAdmin, setIsAdmin] = useState(false);

    let [dataLoaded, setDataLoaded] = useState(false);
    let [data, setData] = useState({})
    let [myInformation, setMyInformation] = useState({})

    let [needInfoRefresh, setNeedInfoRefresh] = useState(false)


    useEffect(() => {
        proxy.get("/api/islogin").then((loginRes) => {
            if (loginRes.data.isLogin) {
                setIsLoggedIn(true);
                setIsAdmin(loginRes.data.isAdmin);
            }
            setLoginLoaded(true)
        });
    }, [])

    useEffect(() => {
        if (isLoggedIn) {
            proxy.get("/api/myinformation").then(info => {
                setMyInformation(info.data.data)
                proxy.get("/api/teachers").then((teacherIds) => {
                    let data = {}
                    data.teachers = teacherIds.data.data;
                    if (needInfoRefresh) {
                        setNeedInfoRefresh(false)
                        return;
                    }
                    setData(data)
                    setDataLoaded(true)
                });
            })
        }
    }, [isLoggedIn, needInfoRefresh])

    let onPageLogin = (isAdmin) => {
        setIsAdmin(isAdmin);
        setIsLoggedIn(true)
    }
    return (
        <div className="main-container">
            {loginLoaded ? (
                isLoggedIn ? (
                    dataLoaded ? (
                        isAdmin ? (<AdminPage onLoginChange={setIsLoggedIn.bind(this)} data={data}
                                              myInformation={myInformation}></AdminPage>)
                            : <UserPage onLoginChange={setIsLoggedIn.bind(this)} data={data}
                                        myInformation={myInformation}
                                        setNeedInfoRefresh={setNeedInfoRefresh.bind(this)}></UserPage>
                    ) : null
                ) : (
                    <LoginPage onLoginChange={onPageLogin.bind(this)}></LoginPage>
                )
            ) : null/** Loading Page(빈 화면) */}
        </div>
    );
}
export default App;